
/* Widget Web Messenger */
document.addEventListener("DOMContentLoaded", () => {
    const container = document.getElementById("messages-container");
    const POLL_INTERVAL = 5000; // intervalo de fetch
    const DISPLAY_DELAY = 500; // intervalo intra-backlog
    const MAX_MESSAGES = 5; // quantas manter no DOM
    const FADE_TOP = 3; // quantas do topo vão ficar semitransparentes
    const MAX_SET_SIZE = 100; // tamanho máximo do conjunto de mensagens processadas
  
    // Usar Map em vez de Set para manter registros com timestamps (melhor para remoção)
    let processedMessages = new Map();
    let queue = [];
    let processing = false;
    let lastFetchTime = 0; // Track last fetch time
    let isActive = true;
  
    // Limita o tamanho do conjunto de mensagens processadas - versão otimizada
    function limitProcessedMessagesSize() {
      if (processedMessages.size <= MAX_SET_SIZE) return;
  
      // Obter e ordenar as entradas por timestamp (mais antigas primeiro)
      const entries = Array.from(processedMessages.entries()).sort(
        (a, b) => a[1] - b[1]
      );
  
      // Remover as mensagens mais antigas, deixando apenas MAX_SET_SIZE
      const toDelete = entries.slice(0, entries.length - MAX_SET_SIZE);
      toDelete.forEach(([key]) => processedMessages.delete(key));
    }
  
    // Busca apenas mensagens novas
    async function fetchAndQueue() {
      try {
        if (!isActive) {
          return;
        }
  
        const res = await fetch("/api/getChat");
        const js = await res.json();
        const msgs = js.success && js.success.chat ? js.success.chat : [];
  
        // Filtragem mais eficiente usando Map para verificar duplicações
        const uniqueMap = new Map();
        msgs.forEach((msg) => {
          const key = `${msg.id}-${msg.Timestamp}-${msg.Name}-${msg.Message}`;
          uniqueMap.set(key, msg);
        });
        const uniqueMsgs = Array.from(uniqueMap.values());
  
        // Filtrar mensagens mais recentes que o último fetch e ordenar
        const newMessages = uniqueMsgs
          .filter((m) => m.Timestamp > lastFetchTime)
          .sort((a, b) => a.Timestamp - b.Timestamp);
  
        // Atualizar o timestamp do último fetch
        if (newMessages.length > 0) {
          lastFetchTime = Math.max(...newMessages.map((m) => m.Timestamp));
        }
  
        // Na primeira carga, limitar apenas às mensagens mais recentes
        if (processedMessages.size === 0 && newMessages.length > MAX_MESSAGES) {
          newMessages.splice(0, newMessages.length - MAX_MESSAGES);
        }
  
        // Processar cada mensagem única
        newMessages.forEach((m) => {
          const msgId = `${m.Name}-${m.Message}-${m.Timestamp}`;
  
          if (!processedMessages.has(msgId)) {
            queue.push(m);
            processedMessages.set(msgId, m.Timestamp); // Armazenar o timestamp para remoção posterior
          }
        });
  
        if (!processing) {
          processQueue();
        }
        limitProcessedMessagesSize();
      } catch (e) {
        console.error("Erro fetch:", e);
      }
    }
  
    function processQueue() {
      if (queue.length === 0) {
        processing = false;
        return;
      }
  
      processing = true;
      const m = queue.shift();
  
      // Usar requestAnimationFrame para melhor desempenho visual
      requestAnimationFrame(() => {
        appendMessage(m);
        setTimeout(() => requestAnimationFrame(processQueue), DISPLAY_DELAY);
      });
    }
  
    function appendMessage(m) {
      const div = document.createElement("div");
      div.className = `message type-${m.type || "player"}`;
      //div.textContent = `[Sv${m.server || 1}] ${m.Name}: ${m.Message}`;
      div.textContent = `[POST] ${m.Name}: ${m.Message}`;
  
      container.appendChild(div);
  
      // Remover mensagens antigas
      while (container.children.length > MAX_MESSAGES) {
        container.removeChild(container.firstChild);
      }
  
      // Scroll para mostrar novas mensagens
      container.scrollTop = container.scrollHeight;
  
      // Atualizar opacidade apenas das mensagens que precisam mudar
      updateOpacities();
    }
  
    function updateOpacities() {
      const items = container.children;
      const total = items.length;
  
      // Apenas atualizar as opacidades das primeiras FADE_TOP mensagens
      // ou todas se tiverem menos que FADE_TOP
      const updateCount = Math.min(FADE_TOP, total);
  
      for (let i = 0; i < updateCount; i++) {
        // i=0 → 0.3; i=FADE_TOP-1 → 0.8
        const o = 0.3 + (i / (FADE_TOP - 1)) * 0.5;
        items[i].style.opacity = o;
      }
  
      // Se tiver novas mensagens que precisam de opacidade 1
      if (total > FADE_TOP) {
        items[FADE_TOP].style.opacity = 1;
      }
    }
  
    window.addEventListener("visibilitychange", () => {
      isActive = document.visibilityState === "visible" ? true : false;
    });
  
    // Carga inicial e polling
    fetchAndQueue();
  
    setInterval(fetchAndQueue, POLL_INTERVAL);
  });
  